var _path, _path2, _circle, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgReadActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 91,
    height: 42,
    viewBox: "0 0 91 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M90 41.5H90.5V41V25C90.5 11.469 79.531 0.5 66 0.5H21C9.67816 0.5 0.5 9.67816 0.5 21C0.5 32.3218 9.67816 41.5 21 41.5H90Z",
    fill: "url(#paint0_linear_1494_503)",
    stroke: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M44.386 28V14.998H48.478C49.2113 14.998 49.8053 15.174 50.26 15.526C50.7147 15.8633 50.942 16.406 50.942 17.154V19.266C50.942 20.014 50.7147 20.5933 50.26 21.004C49.82 21.4147 49.2187 21.6347 48.456 21.664V21.642C48.9253 21.6713 49.2773 21.84 49.512 22.148C49.7467 22.4413 49.952 22.9033 50.128 23.534L51.47 28H49.93L48.742 23.622C48.6247 23.2113 48.4707 22.8447 48.28 22.522C48.104 22.1847 47.8107 22.016 47.4 22.016H45.816V28H44.386ZM45.816 21.026H47.752C48.4267 21.026 48.896 20.872 49.16 20.564C49.4387 20.2413 49.578 19.772 49.578 19.156V17.396C49.578 16.8533 49.446 16.4573 49.182 16.208C48.9327 15.944 48.544 15.812 48.016 15.812H45.816V21.026ZM56.0914 28.198C55.358 28.198 54.764 28.1173 54.3094 27.956C53.8547 27.78 53.5247 27.4647 53.3194 27.01C53.114 26.5553 53.0114 25.8953 53.0114 25.03V19.596C53.0114 18.5693 53.2387 17.8653 53.6934 17.484C54.1627 17.1027 54.9327 16.912 56.0034 16.912C57.0447 16.912 57.7927 17.1027 58.2474 17.484C58.7167 17.8653 58.9514 18.5693 58.9514 19.596V22.412H54.3754V25.492C54.3754 26.196 54.4854 26.6873 54.7054 26.966C54.9254 27.23 55.3727 27.362 56.0474 27.362C56.6634 27.362 57.074 27.23 57.2794 26.966C57.4847 26.702 57.5874 26.2107 57.5874 25.492V24.084H58.9514V25.008C58.9514 25.8587 58.8487 26.5187 58.6434 26.988C58.438 27.4427 58.1227 27.758 57.6974 27.934C57.2867 28.11 56.7514 28.198 56.0914 28.198ZM54.3754 21.708H57.5874V19.552C57.5874 18.936 57.4847 18.4887 57.2794 18.21C57.074 17.9313 56.6487 17.792 56.0034 17.792C55.358 17.792 54.9254 17.9313 54.7054 18.21C54.4854 18.4887 54.3754 18.936 54.3754 19.552V21.708ZM62.8823 28.154C62.545 28.154 62.2003 28.1027 61.8483 28C61.511 27.912 61.2177 27.6993 60.9683 27.362C60.7337 27.01 60.6163 26.4673 60.6163 25.734V24.678C60.6163 23.9447 60.8363 23.358 61.2763 22.918C61.731 22.4633 62.347 22.06 63.1243 21.708C63.623 21.4587 64.0263 21.2387 64.3343 21.048C64.657 20.8573 64.899 20.6447 65.0603 20.41C65.2217 20.1753 65.3023 19.86 65.3023 19.464V19.002C65.3023 18.65 65.229 18.3787 65.0823 18.188C64.9357 17.9973 64.7377 17.8653 64.4883 17.792C64.2537 17.7187 64.0043 17.682 63.7403 17.682C63.0803 17.682 62.6477 17.8653 62.4423 18.232C62.237 18.584 62.1343 19.112 62.1343 19.816V20.74H60.8803V19.684C60.8803 19.1413 60.9537 18.6647 61.1003 18.254C61.247 17.8287 61.5257 17.4987 61.9363 17.264C62.347 17.0147 62.9483 16.89 63.7403 16.89C64.5763 16.89 65.1997 16.9853 65.6103 17.176C66.0357 17.3667 66.3143 17.638 66.4463 17.99C66.593 18.342 66.6663 18.76 66.6663 19.244V28H65.3243L65.3023 26.636C65.1263 27.1347 64.811 27.516 64.3563 27.78C63.9017 28.0293 63.4103 28.154 62.8823 28.154ZM63.3883 27.23C64.0483 27.23 64.525 26.9953 64.8183 26.526C65.1263 26.0567 65.2803 25.4333 65.2803 24.656V21.18C65.1337 21.4147 64.8917 21.6273 64.5543 21.818C64.217 22.0087 63.8723 22.1993 63.5203 22.39C63.0217 22.6833 62.633 22.9913 62.3543 23.314C62.0903 23.622 61.9583 24.0547 61.9583 24.612V25.47C61.9583 25.998 62.0317 26.3867 62.1783 26.636C62.325 26.8853 62.5083 27.0467 62.7283 27.12C62.9483 27.1933 63.1683 27.23 63.3883 27.23ZM71.2286 28.176C70.6859 28.176 70.2386 28.11 69.8866 27.978C69.5346 27.8313 69.2559 27.6333 69.0506 27.384C68.8599 27.12 68.7279 26.7973 68.6546 26.416C68.5812 26.02 68.5446 25.5727 68.5446 25.074V19.64C68.5446 19.244 68.5812 18.8847 68.6546 18.562C68.7426 18.2247 68.8819 17.9387 69.0726 17.704C69.2632 17.4547 69.5199 17.264 69.8426 17.132C70.1652 16.9853 70.5759 16.912 71.0746 16.912C71.6612 16.912 72.1159 17 72.4386 17.176C72.7759 17.352 73.0179 17.5647 73.1646 17.814V14.14H74.5286V28H73.5826L73.4506 26.966C73.3626 27.1567 73.2306 27.3473 73.0546 27.538C72.8932 27.714 72.6659 27.868 72.3726 28C72.0939 28.1173 71.7126 28.176 71.2286 28.176ZM71.4706 27.34C71.8959 27.34 72.2259 27.2667 72.4606 27.12C72.6952 26.9587 72.8566 26.7533 72.9446 26.504C73.0472 26.2547 73.1059 25.9833 73.1206 25.69C73.1499 25.382 73.1646 25.0813 73.1646 24.788V18.826C73.1206 18.694 73.0399 18.5473 72.9226 18.386C72.8199 18.2247 72.6586 18.0853 72.4386 17.968C72.2186 17.8507 71.9179 17.792 71.5366 17.792C71.1112 17.792 70.7886 17.8507 70.5686 17.968C70.3486 18.0853 70.1872 18.2467 70.0846 18.452C69.9966 18.6427 69.9452 18.8627 69.9306 19.112C69.9159 19.3613 69.9086 19.618 69.9086 19.882V25.25C69.9086 25.602 69.9306 25.9393 69.9746 26.262C70.0186 26.5847 70.1506 26.8487 70.3706 27.054C70.5906 27.2447 70.9572 27.34 71.4706 27.34Z",
    fill: "white"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 21,
    cy: 21,
    r: 18,
    fill: "url(#paint1_linear_1494_503)",
    stroke: "white",
    strokeWidth: 2
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1494_503)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.8601 15.8594H30.0601",
    stroke: "white",
    strokeWidth: 1.72,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeDasharray: "3.52 3.52"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.8601 21.2598H30.0601",
    stroke: "white",
    strokeWidth: 1.72,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.8601 26.459H30.0601",
    stroke: "white",
    strokeWidth: 1.72,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeDasharray: "4.69 4.69"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1494_503",
    x1: 24.5,
    y1: 11,
    x2: 85,
    y2: 41,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#147BBD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#0C5EB8",
    stopOpacity: 0.79
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0037B1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1494_503",
    x1: 6.5,
    y1: 10.5,
    x2: 27,
    y2: 36.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17B3E0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.485,
    stopColor: "#0D78C5",
    stopOpacity: 0.54
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#023AA8"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1494_503"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18.92,
    height: 12.32,
    fill: "white",
    transform: "translate(12 15)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReadActive);
export default __webpack_public_path__ + "static/media/ReadActive.97581993ea175c1be29f104f698b9d5c.svg";
export { ForwardRef as ReactComponent };